import { createFileRoute } from '@tanstack/react-router';
import StaysManagement from '../../components/manager/StaysManagement';
import StaffPortal from '../../components/portals/StaffPortal';

export const Route = createFileRoute('/staff/stays')({
  component: StaffStaysRoute,
});

function StaffStaysRoute() {
  return (
    <StaffPortal>
      <StaysManagement />
    </StaffPortal>
  );
}
